import { createContext, FC, ReactNode, useContext, useState } from 'react';
import { Brand, Item } from '../types';

interface AccountCreationContextProps {
	dob: { day: string; month: string; year: string };
	shoppingPreference: string;
	fashionStyle: string;
	brands: Array<Brand>;
	size: string;
	items: Array<Item>;
	email: string;
	setDob: (date: { day: string; month: string; year: string }) => void;
	setShoppingPreference: (preference: string) => void;
	setFashionStyle: (style: string) => void;
	setBrands: (brands: Array<Brand>) => void;
	setSize: (size: string) => void;
	setItems: (item: Array<Item>) => void;
	setEmail: (email: string) => void;
	resetAccountCreationState: () => void;
	selectedProducts: any[];
  	setSelectedProducts: (arr: any[]) => void;
}

const AccountCreationContext = createContext<AccountCreationContextProps | undefined>(undefined);

export const useAccountCreationContext = () => {
	const context = useContext(AccountCreationContext);
	if (!context) {
		throw new Error('useAccountCreationContext must be used within a AccountCreationContext');
	}
	return context;
};

export const AccountCreationProvider: FC<{ children: ReactNode }> = ({ children }) => {
	const [dob, setDob] = useState<{ day: string; month: string; year: string }>({ day: '', month: '', year: '' });
	const [shoppingPreference, setShoppingPreferenceState] = useState<string>('');
	const [fashionStyle, setFashionStyle] = useState<string>('');
	const [brands, setBrands] = useState<Array<Brand>>([]);
	const [size, setSize] = useState<string>('');
	const [items, setItems] = useState<Array<Item>>([]);
	const [email, setEmail] = useState<string>('');
	const [selectedProducts, setSelectedProducts] = useState<any[]>([]);

	// Add logging wrapper for setShoppingPreference
	const setShoppingPreference = (preference: string) => {
		console.debug('🔍 [ACCOUNT_CREATION_CONTEXT] Setting shopping preference:', preference);
		setShoppingPreferenceState(preference);
	};

	const resetAccountCreationState = () => {
		setDob({ day: '', month: '', year: '' });
		setShoppingPreferenceState('');
		setFashionStyle('');
		setBrands([]);
		setSize('');
		setItems([]);
		setEmail('');
		setSelectedProducts([]);
		
	};

	return (
		<AccountCreationContext.Provider
			value={{
				dob,
				setDob,
				shoppingPreference,
				setShoppingPreference,
				fashionStyle,
				setFashionStyle,
				brands,
				setBrands,
				size,
				setSize,
				items,
				setItems,
				email,
				setEmail,
				resetAccountCreationState,
				selectedProducts,
    			setSelectedProducts,
			}}
		>
			{children}
		</AccountCreationContext.Provider>
	);
};
